import Goal from '../../models/Goal';
import { ApiState } from '../../utils/requestAction';
import requestReducer from '../requestReducer';

export interface GoalStatsType {
  goalData: Goal;  
  codeZone?: string
  codeVendor?: string
  codeClient?: string 
  zone: string;
  vendor: string;
  client: string;
  goal: number;
  liquidationTotal: number
  total: number;
  monthly?: number[]
}


export interface GoalStatsState extends ApiState {
  goalStats?: GoalStatsType[]
}

export default requestReducer<GoalStatsState>('GOAL_STATS')
